import React from 'react';
const APP_VERSION = '3.0';

export default function Help(props) {
	return (
		<div style={{ width: '100%' }}>
			<div style={{ fontSize: 'x-large', marginTop: 60 }}>
				wlang-trainer {APP_VERSION}
			</div>

			<div style={{ fontSize: 'large', marginTop: 20 }}>
				wlang-trainer helps to study words and to recognize english.
			</div>

			<div style={{ fontSize: 'large', marginTop: 20 }}>
				wlang-trainer was made using react.js.
			</div>

			<div style={{ textAlign: 'right', marginTop: 20, width: '95%' }}>
				Sergiy Vovk. 2017 - 2019.<br/>
				<a href="http://vovk.happyuser.info"
				   target="_blank"
				   rel="noopener noreferrer">vovk.happyuser.info</a>
			</div>

			<div style={{
						textAlign: 'right',
						position: 'absolute',
						bottom: 10,
						width: '90%' }}>
				<button
						onClick={() => {
							props.app.setState({ mode: 'main' }); }}>
					Close
				</button>
			</div>
		</div> );
}


// WEBPACK FOOTER //
// ./src/Help.js